import { useEffect, useState } from 'react';
import { handleAuthCallback } from '@/lib/auth-callback';
import { Loader2, AlertCircle } from 'lucide-react';

export default function AuthCallback() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    handleAuthCallback().then((result) => {
      if (!result.success) {
        setError(result.error || 'Authentication failed');
      }
    });
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-grey-50">
        <div className="card p-8 max-w-md w-full text-center">
          <AlertCircle className="w-12 h-12 text-error mx-auto mb-4" />
          <h1 className="text-heading-3 text-secondary mb-2">Authentication Failed</h1>
          <p className="text-grey-500 mb-6">{error}</p>
          <a href="/admin" className="btn-primary inline-block">
            Try Again
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-grey-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto mb-4" />
        <p className="text-grey-500">Completing sign in...</p>
      </div>
    </div>
  );
}
